import { ClickAwayListener } from "@mui/material";
import {
  CommonMFE,
  Helpers,
  MFE_NAMES,
  ReactMFE,
} from "@tpd-web-common-libs/nodejs-library";
import React, { ReactNode, useEffect, useState } from "react";
import {
  ContainerDiv,
  Logo,
  LogoWrapper,
  AccessibilityWrapper,
  HamburgerIcon,
  IconWrapper,
  HamburgerMenu,
  Collapsible,
  MobileSearch,
  TabletSearch,
  SubMenu,
  SubMenuHeader,
  SubMenuHeaderCta,
  SubMenuHeaderIcon,
  SubMenuDropdown,
  DropdownIcon,
  Dropdown,
  DropdownUl,
  DropdownLink,
  DropdownLi,
  SubMenuContent,
  SubMenuLink,
  SubMenuLinkWrapper,
  SubMenuIcon,
  SubMenuTitle,
  SubMenuAngleIcon,
  SubMenuIconWrapper,
  SubMenuMiddleLevelTitle,
  SubMenuLeafLevelLink,
  SubMenuBack,
  SubMenuBackIcon,
  SubMenuBackText,
  SubMenuLinkA,
  SubMenuHeaderMobile,
  SubMenuHeaderMobileLink,
  SubMenuHeaderMobileIcon,
  SubMenuDropdownMobile,
  DropdownIconMobile,
  DropdownMobile,
  DropdownMobileUl,
  DropdownMobileLi,
  DropdownMobileLink,
  FlexContainer,
  LoginMobile,
  MobileSearchDropdown,
} from "./LowerHeader.style";

import ENV_CONFIG from "../../../../../../config/envConfig/esm";

import { stringToHexColor } from "../App.mock";
import { LINK_PREVENTIVATORE } from "./desktop/LowerHeaderDesktop";
import CasellaRicercaHeader from "./casella-ricerca-header/CasellaRicercaHeader";
import Login from "../login/Login";

type TLowerHeaderProps = {
  id: string;
  navigationMenu: any;
  __host__: any;
  isEditMode: boolean;
  menuLivello1: any;
  corporateLinks: any;
  configHeader: any;
  logoPath: string;
  tipo?: string;
  showHideModal: () => void;
  config: any;
};

export const enum LINK {
  AZIENDE = "/aziende",
  HOMEPAGE = "/homepage",
}

const LowerHeader = (props: TLowerHeaderProps) => {
  const {
    __host__,
    isEditMode,
    navigationMenu,
    menuLivello1,
    corporateLinks,
    configHeader,
    logoPath,
    id: containerID,
    tipo,
    showHideModal: showModal,
    config,
  } = props;
  const [openMenu, setOpenMenu] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openDropdownMobile, setOpenDropdownMobile] = useState(false);
  const [menuNavigationDepth, setMenuNavigationDepth] = useState([]);
  const [superUserImpersonification, setsuperUserImpersonification] =
    useState(true);

  const prodottoUnicoActive = ENV_CONFIG.PRODOTTO_UNICO_ACTIVE === "on";

  useEffect(() => {
    Helpers.SessionHelper.getData("_impersonification").then((value) => {
      if (value !== undefined && value === false)
        setsuperUserImpersonification(false);
    });
  }, []);

  const isHCLAuthoringPage = Helpers.PageHelper.isHCLAuthoringPage();

  const rootPath = Helpers.EnvironmentHelper.isClientSide() ?
    (isHCLAuthoringPage ? window.location.pathname.split("/")[2] :
      window.location.pathname.split("/")[1])
    : "";

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
    setOpenDropdown(false);
    setOpenDropdownMobile(false);
  };

  const closeDropdown = () => {
    setOpenDropdown(false);
  };

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const closeDropdownMobile = () => {
    setOpenDropdownMobile(false);
  };

  const toggleDropdownMobile = () => {
    setOpenDropdownMobile(!openDropdownMobile);
  };

  const clickOnLink = (href: string) => {
    setMenuNavigationDepth(menuNavigationDepth.concat(href));
  };

  const clickOnGoBack = () => {
    setMenuNavigationDepth(menuNavigationDepth.slice(0, -1));
  };

  const enum MENU_LIVELLO_1_URLS {
    SERVIZIO_CLIENTI = "/tpdweb/servizio-clienti",
    TROVA_AGENZIE = "/tpdweb/trova-agenzie",
  }

  function renderContattiButton(): ReactNode {
    const contattiData = menuLivello1.map((menuData) => {
      if (menuData.url === MENU_LIVELLO_1_URLS.SERVIZIO_CLIENTI) {
        return (
          <IconWrapper
            key={CommonMFE.generateID(menuData.id, "renderContattiButton")}
            href={menuData.url}
            data-disabled={isEditMode}
            aria-label={"Contatti"}
            __deps__={React}
            title={"Servizio clienti"}
          >
            <i className={menuData.icon} />
          </IconWrapper>
        );
      }
    });
    return contattiData;
  }

  function renderMenuLivello1Cta(): ReactNode {
    const cercaAgenziaData = menuLivello1.map((menuData) => {
      if (menuData.url === MENU_LIVELLO_1_URLS.TROVA_AGENZIE) {
        return (
          <SubMenuHeaderCta
            href={menuData.url}
            title={menuData.name}
            key={CommonMFE.generateID(menuData.id, "renderMenuLivello1Cta")}
            data-disabled={isEditMode}
            __deps__={React}
          >
            <SubMenuHeaderIcon className={menuData.icon} title={"Trova agenzia"} />
            {menuData.name}
          </SubMenuHeaderCta>
        );
      }
    });
    return cercaAgenziaData;
  }

  const renderRootLevelSubMenu = (menuLink: any, index) => (
    <SubMenuLinkWrapper
      key={CommonMFE.generateID(index, "renderRootLevelSubMenu")}
      onClick={() => clickOnLink(menuLink.url)}
    >
      <SubMenuLink color={stringToHexColor(menuLink.colorClassDesktop)}>
        <SubMenuIconWrapper
          color={stringToHexColor(menuLink.colorClassDesktop)}
          className={menuLink.iconBackground}
        >
          <SubMenuIcon className={menuLink.icon} />
        </SubMenuIconWrapper>
        <SubMenuTitle color={stringToHexColor(menuLink.colorClassDesktop)}>
          {menuLink.name}
        </SubMenuTitle>
        <SubMenuAngleIcon className="icon-Freccia-dx" />
      </SubMenuLink>
    </SubMenuLinkWrapper>
  );

  const renderMiddleLevelSubMenu = (color: string, subMenu: any) => {
    return subMenu.map((middleLevelLink: any) => (
      <SubMenuLinkWrapper
        key={CommonMFE.generateID(
          middleLevelLink.url,
          "renderMiddleLevelSubMenu"
        )}
        onClick={() => clickOnLink(middleLevelLink.url)}
      >
        <SubMenuLink color={stringToHexColor(color)}>
          <SubMenuMiddleLevelTitle color={stringToHexColor(color)}>
            {middleLevelLink.name}
          </SubMenuMiddleLevelTitle>
          <SubMenuAngleIcon className="icon-Freccia-dx" />
        </SubMenuLink>
      </SubMenuLinkWrapper>
    ));
  };

  const renderLeafLevelSubMenu = (leafLevelLink: any) => (
    <SubMenuLinkWrapper
      key={CommonMFE.generateID(leafLevelLink.id, "renderLeafLevelSubMenu")}
    >
      <SubMenuLeafLevelLink
        href={leafLevelLink.url}
        data-disabled={isEditMode}
        __deps__={React}
      >
        {leafLevelLink.name}
      </SubMenuLeafLevelLink>
    </SubMenuLinkWrapper>
  );

  const renderSubMenu = () => {
    let subMenu = [];
    if (menuNavigationDepth.length === 1) {
      const currentData = navigationMenu.find(
        (middleLevelLink: any) => middleLevelLink.url === menuNavigationDepth[0]
      );
      subMenu = renderMiddleLevelSubMenu(
        currentData.colorClassDesktop,
        currentData.subMenu
      );
      subMenu.unshift(
        <SubMenuLinkWrapper
          key={CommonMFE.generateID(currentData.id, "submenu")}
        >
          <SubMenuLinkA
            href={currentData.url}
            color={stringToHexColor(currentData.colorClassDesktop)}
            data-disabled={isEditMode}
            __deps__={React}
          >
            <SubMenuIconWrapper
              color={stringToHexColor(currentData.colorClassDesktop)}
              className={currentData.iconBackground}
            >
              <SubMenuIcon className={currentData.icon} />
            </SubMenuIconWrapper>
            <SubMenuTitle
              color={stringToHexColor(currentData.colorClassDesktop)}
            >
              {currentData.name}
            </SubMenuTitle>
            <SubMenuAngleIcon className="icon-Freccia-dx" />
          </SubMenuLinkA>
        </SubMenuLinkWrapper>
      );
    } else if (menuNavigationDepth.length === 2) {
      const currentMenu = navigationMenu.find(
        (middleLevelLink: any) => middleLevelLink.url === menuNavigationDepth[0]
      );
      const currentData = currentMenu.subMenu.find(
        (leafLevelLink: any) => leafLevelLink.url === menuNavigationDepth[1]
      );
      subMenu = currentData.subMenu.map(renderLeafLevelSubMenu);
      subMenu.unshift(
        <SubMenuLinkWrapper
          key={CommonMFE.generateID(currentData.id, "submenulinkwrapper")}
        >
          <SubMenuLinkA
            href={LINK_PREVENTIVATORE[currentData.url]}
            data-disabled={isEditMode}
            __deps__={React}
            color={stringToHexColor(currentMenu.colorClassDesktop)}
          >
            <SubMenuMiddleLevelTitle
              color={stringToHexColor(currentMenu.colorClassDesktop)}
            >
              {currentData.name}
            </SubMenuMiddleLevelTitle>
            <SubMenuAngleIcon className="icon-Freccia-dx" />
          </SubMenuLinkA>
        </SubMenuLinkWrapper>
      );
    } else {
      subMenu = navigationMenu.map(renderRootLevelSubMenu);
    }
    return (
      <SubMenuContent
        className={`${menuNavigationDepth.length === 0 ? "padding-top" : ""}${Helpers.LoginHelper.userLogged ? " padding-top-logged" : ""
          }`}
      >
        {menuNavigationDepth.length > 0 && (
          <SubMenuBack onClick={clickOnGoBack}>
            <SubMenuBackIcon className="icon-Freccia-sx" />
            <SubMenuBackText>Torna indietro</SubMenuBackText>
          </SubMenuBack>
        )}
        {subMenu}
      </SubMenuContent>
    );
  };

  const storeCartAndRedirect = async () => {
    try {
      await Helpers.SessionHelper.setData("pu_data_props", {
        showCarrello: true,
      });
      Helpers.RouterHelper.goTo("/prodotto-unico");
    } catch (error) {
      console.error("Failed to store cart", error);
    }
  };

  //TODO: rebranding 2025, rerendering
  const [isClient, setIsClient] = useState(false)
 
  useEffect(() => {
    setIsClient(true)
  }, [])

  const RebrandingLogoSwitch = () => { 
    return Helpers.BrandNameHelper.brand() === Helpers.EBrand.UNIPOL ?
    <Logo src='/NextAssets/images/logo_unipol.svg' alt={`${Helpers.BrandNameHelper.brandName()} Logo`}/> :
    <Logo src='/NextAssets/images/logo_unipolsai.png' alt={`${Helpers.BrandNameHelper.brandName()} Logo`}/>
  }
  //END TODO

  return (
    <ContainerDiv>
      <LogoWrapper>
        <ReactMFE.Link
          href={
            rootPath === "aziende" ?
              (isHCLAuthoringPage ? `/tpdweb/aziende` : LINK.AZIENDE) :
              (isHCLAuthoringPage ? `/tpdweb/homepage` : LINK.HOMEPAGE)
          }
          title={`${Helpers.BrandNameHelper.brandName()} Assicurazioni`}
          data-disabled={isEditMode}
          __deps__={React}
        >

          {/* {//TODO: logica per server side rebranding 2025, rerendering da eliminare a valle del rebranding } */
          isClient || !isClient ? 
          <RebrandingLogoSwitch></RebrandingLogoSwitch>
          : 
          <RebrandingLogoSwitch></RebrandingLogoSwitch>
        }
        </ReactMFE.Link>
      </LogoWrapper>

      <FlexContainer>
        {configHeader.search_bar && (
          <TabletSearch>
            <CasellaRicercaHeader
              __host__={__host__}
              id={CommonMFE.generateID(
                containerID,
                `${MFE_NAMES.tpdHeader}-${MFE_NAMES.tpdCasellaRicercaHeader}-tablet`
              )}
              isEditMode={isEditMode}
              config={config.tpdCasellaRicercaHeader}></CasellaRicercaHeader>
          </TabletSearch>
        )}

        <AccessibilityWrapper>
          {prodottoUnicoActive && (
            // * CARRELLO PRODOTTO UNICO *
            <IconWrapper
              __deps__={React}
              aria-label=""
              onClick={tipo === "PF" ? storeCartAndRedirect : () => showModal()}
            >
              <i className="icon-Cart" />
            </IconWrapper>
          )}
          {configHeader.account_menu && (
            <>
              {renderContattiButton()}
              <IconWrapper
                __deps__={React}
                href={
                  Helpers.LoginHelper.userLogged
                    ? superUserImpersonification
                      ? "area_riservata/home"
                      : "area_riservata/home-superuser"
                    : "/accesso"
                }
                aria-label="Accesso"
                data-disabled={isEditMode}
              >
                <i className="icon-Area-riservata" />
              </IconWrapper>
              <HamburgerMenu onClick={toggleMenu}>
                <HamburgerIcon
                  className={`${openMenu ? "icon-Chiudi " : "icon-Panino "}`}
                ></HamburgerIcon>
              </HamburgerMenu>
            </>
          )}
        </AccessibilityWrapper>
        {configHeader.search_bar && (
          <MobileSearch>
            <div className="casella-di-ricerca-wrapper">
              <CasellaRicercaHeader
                __host__={__host__}
                id={CommonMFE.generateID(
                  containerID,
                  `${MFE_NAMES.tpdHeader}-${MFE_NAMES.tpdCasellaRicercaHeader}-mobile`
                )}
                isEditMode={isEditMode}
                config={config.tpdCasellaRicercaHeader}></CasellaRicercaHeader>
            </div>
          </MobileSearch>
        )}

        <Collapsible in={openMenu} timeout={750} unmountOnExit>
          <SubMenu>
            <SubMenuHeader
              className={
                Helpers.LoginHelper.userLogged ? "submenu-header-logged" : ""
              }
            >
              {renderMenuLivello1Cta()}
              {configHeader.menu_top && (
                <ClickAwayListener onClickAway={closeDropdown}>
                  <SubMenuDropdown
                    className={`${openDropdown ? "dropdown-opened " : ""}`}
                    onClick={toggleDropdown}
                  >
                    {corporateLinks.sitoCliente.name}
                    <DropdownIcon
                      className={
                        openDropdown ? "icon-Freccia-up" : "icon-Freccia-down"
                      }
                    />
                    <Dropdown in={openDropdown} timeout={0} unmountOnExit>
                      <DropdownUl>
                        <DropdownLi />
                        {corporateLinks.sitoCliente.subMenu.map(
                          (corporateLink, index) => (
                            <DropdownLi
                              key={CommonMFE.generateID(
                                corporateLink.id,
                                "corporate-link",
                                index
                              )}
                            >
                              <DropdownLink
                                __deps__={React}
                                href={corporateLink.url}
                                title={corporateLink.name}
                                data-disabled={isEditMode}
                              >
                                {corporateLink.name}
                              </DropdownLink>
                            </DropdownLi>
                          )
                        )}
                      </DropdownUl>
                    </Dropdown>
                  </SubMenuDropdown>
                </ClickAwayListener>
              )}
              <LoginMobile>
                <Login
                  __host__={__host__}
                  id={CommonMFE.generateID(
                    containerID,
                    `${MFE_NAMES.tpdHeader}-${MFE_NAMES.tpdLoginHeaderContainer}`
                  )}
                  isEditMode={isEditMode}
                  isLogoutOnly={config.tpdLoginHeaderNewArc.isLogoutOnly}
                  config={!config ? {} : config.tpdLoginHeaderNewArc}></Login>
              </LoginMobile>
            </SubMenuHeader>
            {configHeader.search_bar && (
              <MobileSearchDropdown
                className={
                  Helpers.LoginHelper.userLogged
                    ? "casella-di-ricerca-wrapper-logged"
                    : ""
                }
              >
                <div className="casella-di-ricerca-wrapper-dropdown">
                  <ReactMFE.Remote
                    __deps__={React}
                    __host__={__host__}
                    __mfeName__={MFE_NAMES.tpdCasellaRicercaHeader}
                    isEditMode={isEditMode}
                    {...config.tpdCasellaRicercaHeader}
                    id={CommonMFE.generateID(
                      containerID,
                      `${MFE_NAMES.tpdHeader}-${MFE_NAMES.tpdCasellaRicercaHeader}-mobile-dropdown`
                    )}
                  />
                </div>
              </MobileSearchDropdown>
            )}
            {configHeader.navigation_menu && <>{renderSubMenu()}</>}
            <SubMenuHeaderMobile>
              <SubMenuHeaderMobileLink
                href={menuLivello1[0].url}
                title={menuLivello1[0].name}
                key={CommonMFE.generateID(
                  menuLivello1[0].id,
                  "submenuheadermobilelink"
                )}
                data-disabled={isEditMode}
                __deps__={React}
              >
                <SubMenuHeaderMobileIcon className={menuLivello1[0].icon} />
                {menuLivello1[0].name}
              </SubMenuHeaderMobileLink>
              {configHeader.menu_top && (
                <ClickAwayListener onClickAway={closeDropdownMobile}>
                  <SubMenuDropdownMobile
                    className={`${openDropdownMobile ? "dropdown-opened " : ""
                      }`}
                    onClick={toggleDropdownMobile}
                  >
                    {corporateLinks.sitoCliente.name}
                    <DropdownIconMobile
                      className={
                        openDropdownMobile
                          ? "icon-Freccia-up"
                          : "icon-Freccia-down"
                      }
                    />
                    <DropdownMobile
                      in={openDropdownMobile}
                      timeout={0}
                      unmountOnExit
                    >
                      <DropdownMobileUl>
                        <DropdownMobileLi />
                        {corporateLinks.sitoCliente.subMenu.map(
                          (corporateLink, index) => (
                            <DropdownMobileLi
                              key={CommonMFE.generateID(
                                corporateLink.id,
                                "corporateLink-sitoCliente",
                                index
                              )}
                            >
                              <DropdownMobileLink
                                __deps__={React}
                                href={corporateLink.url}
                                title={corporateLink.name}
                                data-disabled={isEditMode}
                              >
                                {corporateLink.name}
                              </DropdownMobileLink>
                            </DropdownMobileLi>
                          )
                        )}
                      </DropdownMobileUl>
                    </DropdownMobile>
                  </SubMenuDropdownMobile>
                </ClickAwayListener>
              )}
            </SubMenuHeaderMobile>
          </SubMenu>
        </Collapsible>
      </FlexContainer>
    </ContainerDiv>
  );
};

export default LowerHeader;
